import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { fuseAnimations } from '@mobileia/layout-fuse';
import { SynonymService } from 'src/app/services/synonym.service';
import { AlertService } from 'src/app/services/alert.service';
import { Synonym, SynonymGroup } from 'src/app/entities/synonym';

@Component({
  selector: 'app-synonym-group-add',
  templateUrl: './synonym-group-add.component.html',
  styleUrls: ['./synonym-group-add.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: fuseAnimations
})
export class SynonymGroupAddComponent implements OnInit {

  isLoading = false;
  isSaving = false;
  isEditing = false;
  
  group: SynonymGroup = new SynonymGroup();
  newSynonymPhrase = '';
  addingSynonym = false;
  
  // For editing individual synonyms
  editingSynonymId: number | null = null;
  editingSynonymPhrase = '';

  constructor(
    private synonymService: SynonymService,
    private alertService: AlertService,
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      if (params.id) {
        this.isEditing = true;
        this.loadGroup(params.id);
      }
    });
  }

  loadGroup(id: number): void {
    this.isLoading = true;
    this.synonymService.getGroup(id).subscribe(
      response => {
        this.isLoading = false;
        if (response.success) {
          this.group = response.response;
          if (!this.group.synonyms) {
            this.group.synonyms = [];
          }
        } else {
          this.alertService.showError('Error', 'No se pudo cargar el grupo');
          this.router.navigateByUrl('/synonym-group');
        }
      },
      error => {
        this.isLoading = false;
        this.alertService.showError('Error', 'Error de conexión');
        this.router.navigateByUrl('/synonym-group');
      }
    );
  }

  saveGroup(): void {
    if (!this.group.group_name.trim()) {
      this.alertService.showError('Error', 'El nombre del grupo es requerido');
      return;
    }

    this.isSaving = true;
    this.synonymService.saveGroup({
      id: this.isEditing ? this.group.id : undefined,
      group_name: this.group.group_name.trim(),
      is_active: this.group.is_active
    }).subscribe(
      response => {
        this.isSaving = false;
        if (response.success) {
          if (!this.isEditing) {
            // If creating, redirect to edit mode so user can add synonyms
            this.alertService.showSuccess('Éxito', 'Grupo creado. Ahora puedes agregar sinónimos.');
            this.router.navigateByUrl('/synonym-group-edit/' + response.response.id);
          } else {
            this.alertService.showSuccess('Éxito', 'Grupo actualizado correctamente');
            this.group = response.response;
            if (!this.group.synonyms) {
              this.group.synonyms = [];
            }
          }
        } else {
          this.alertService.showError('Error', 'No se pudo guardar el grupo');
        }
      },
      error => {
        this.isSaving = false;
        this.alertService.showError('Error', 'Error de conexión');
      }
    );
  }

  // ============ Synonym Management ============

  addSynonym(): void {
    if (!this.newSynonymPhrase.trim()) {
      this.alertService.showError('Error', 'Ingrese un sinónimo');
      return;
    }

    this.addingSynonym = true;
    this.synonymService.saveSynonym({
      group_id: this.group.id,
      synonym_phrase: this.newSynonymPhrase.trim()
    }).subscribe(
      response => {
        this.addingSynonym = false;
        if (response.success) {
          if (!this.group.synonyms) {
            this.group.synonyms = [];
          }
          this.group.synonyms.push(response.response);
          this.newSynonymPhrase = '';
          this.alertService.showSuccess('Éxito', 'Sinónimo agregado');
        } else {
          this.alertService.showError('Error', 'No se pudo agregar el sinónimo');
        }
      },
      error => {
        this.addingSynonym = false;
        this.alertService.showError('Error', 'Error de conexión');
      }
    );
  }

  removeSynonym(synonym: Synonym): void {
    this.synonymService.removeSynonym(synonym.id).subscribe(
      response => {
        if (response.success) {
          if (this.group.synonyms) {
            this.group.synonyms = this.group.synonyms.filter(s => s.id !== synonym.id);
          }
          this.alertService.showSuccess('Éxito', 'Sinónimo eliminado');
        } else {
          this.alertService.showError('Error', 'No se pudo eliminar el sinónimo');
        }
      },
      error => {
        this.alertService.showError('Error', 'Error de conexión');
      }
    );
  }

  startEditSynonym(synonym: Synonym): void {
    this.editingSynonymId = synonym.id;
    this.editingSynonymPhrase = synonym.synonym_phrase;
  }

  cancelEditSynonym(): void {
    this.editingSynonymId = null;
    this.editingSynonymPhrase = '';
  }

  saveEditSynonym(synonym: Synonym): void {
    if (!this.editingSynonymPhrase.trim()) {
      this.alertService.showError('Error', 'El sinónimo no puede estar vacío');
      return;
    }

    this.synonymService.saveSynonym({
      id: synonym.id,
      group_id: synonym.group_id,
      synonym_phrase: this.editingSynonymPhrase.trim()
    }).subscribe(
      response => {
        if (response.success) {
          synonym.synonym_phrase = response.response.synonym_phrase;
          synonym.normalized_phrase = response.response.normalized_phrase;
          synonym.word_count = response.response.word_count;
          this.cancelEditSynonym();
          this.alertService.showSuccess('Éxito', 'Sinónimo actualizado');
        } else {
          this.alertService.showError('Error', 'No se pudo actualizar el sinónimo');
        }
      },
      error => {
        this.alertService.showError('Error', 'Error de conexión');
      }
    );
  }

  goBack(): void {
    this.router.navigateByUrl('/synonym-group');
  }
}
